/*
  Ajax add-to-cart for the homepage flavour cards.
  Composes the theme's own machinery: fly-to-cart element, CartLinesUpdateEvent
  (header bubble + cart drawer listen for it), and the same cart-refresh
  contract as product-form.js. The plain form POST remains as no-JS fallback.
*/
import { fetchConfig } from '@theme/utilities';
import { CartLinesUpdateEvent } from '@shopify/events';
import '@theme/fly-to-cart';

if (!window.__nuvaCardAtc) {
  window.__nuvaCardAtc = true;

  var BUTTON_RESET_DELAY = 2000;

  function refreshCart() {
    var cartItems = document.querySelector('cart-items-component');
    if (cartItems) {
      return customElements.whenDefined('cart-items-component').then(function () {
        return cartItems.fetchCartData();
      });
    }
    return fetch((window.Theme && Theme.routes.cart_url ? Theme.routes.cart_url : '/cart') + '.json', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    }).then(function (response) {
      if (!response.ok) throw new Error('Failed to fetch cart: ' + response.status);
      return response.json();
    });
  }

  function flyToCart(button, form) {
    var cartIcon = document.querySelector('.header-actions__cart-icon');
    var card = form.closest('[class*="nuva-flavour-cards__card"], .nuva-flavour-cards__copy');
    var img = card && card.parentElement ? card.parentElement.querySelector('img') : null;
    var src = img && (img.currentSrc || img.src);
    if (!cartIcon || !src) return;
    var fly = document.createElement('fly-to-cart');
    fly.classList.add('fly-to-cart--quick');
    fly.style.setProperty('background-image', 'url(' + src + ')');
    fly.style.setProperty('--start-opacity', '0');
    fly.source = button;
    fly.destination = cartIcon;
    document.body.appendChild(fly);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('nuva-flavour-cards__atc')) return;
    e.preventDefault();

    var button = form.querySelector('button[type="submit"]');
    var formData = new FormData(form);
    formData.delete('return_to'); // only needed for the no-JS full-page fallback

    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (item) {
      if (item.dataset.sectionId) sectionIds.push(item.dataset.sectionId);
    });
    if (sectionIds.length) formData.append('sections', sectionIds.join(','));

    if (button) button.disabled = true;

    var deferred = CartLinesUpdateEvent.createPromise();
    form.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: String(formData.get('id')), quantity: 1 }],
        promise: deferred.promise,
      })
    );

    var cfg = fetchConfig('javascript', { body: formData });
    var addUrl = window.Theme && Theme.routes.cart_add_url ? Theme.routes.cart_add_url : '/cart/add';

    fetch(addUrl, cfg)
      .then(function (response) { return response.json(); })
      .then(function (response) {
        var didError = Boolean(response.status);
        if (!didError && button) {
          flyToCart(button, form);
          var original = button.textContent;
          button.textContent = 'Added';
          setTimeout(function () {
            button.textContent = original;
            button.disabled = false;
          }, BUTTON_RESET_DELAY);
        } else if (button) {
          button.disabled = false;
        }
        return refreshCart().then(function (ajaxCart) {
          deferred.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
            detail: {
              items: ajaxCart.items,
              source: 'nuva-flavour-card',
              itemCount: 1,
              sections: response.sections,
              didError: didError,
            },
          });
        });
      })
      .catch(function (error) {
        if (button) button.disabled = false;
        deferred.reject(error);
      });
  });
}
